import { useApplicationContext } from '@interhyp/util-application-context';
import { useMemo } from 'react';

import { ROUTES } from '../constants/routes';

export function useRoutes() {
  const { hasPermissions } = useApplicationContext();

  return useMemo(() => {
    const activeRoutes = [];

    for (const route of ROUTES) {
      if (route.permissions) {
        const hasPermission = hasPermissions(route.permissions);
        if (!hasPermission) {
          continue;
        }
      }

      if (route.children) {
        const children = [];
        for (const child of route.children) {
          if (child.permissions) {
            const hasPermission = hasPermissions(child.permissions);
            if (!hasPermission) {
              continue;
            }
          }

          children.push(child);
        }

        if (children.length === 0) {
          continue;
        }

        route.children = children;
      }

      activeRoutes.push(route);
    }

    return activeRoutes;
  }, [hasPermissions]);
}
